var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91601 9.08337H7.08268V11.8334H4.33268V13.6667H7.08268V16.4167H8.91601V13.6667H11.666V11.8334H8.91601V9.08337ZM9.83268 0.833374H2.49935C1.49102 0.833374 0.666016 1.65837 0.666016 2.66671V17.3334C0.666016 18.3417 1.48185 19.1667 2.49018 19.1667H13.4993C14.5077 19.1667 15.3327 18.3417 15.3327 17.3334V6.33337L9.83268 0.833374ZM13.4993 17.3334H2.49935V2.66671H8.91601V7.25004H13.4993V17.3334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSurvey);
export default __webpack_public_path__ + "static/media/addSurvey.c8ee40fec5b655e29160df8e9cd944a2.svg";
export { ForwardRef as ReactComponent };